<template>
  <div>
    <validation-observer ref="enableDisableRules">
      <b-form>
        <h5 class="section-label mb-2 mt-2">
          {{ $t('Activate / Deactivate Internet Banking') }}
        </h5>
        <b-row class="match-height mt-1 mb-2">
          <b-col
            md="6"
          >
            <SwitchButton
              v-model="enableDisableIBFormData.isActive"

              :label="enableDisableIBFormData.isActive ? $t('Deactivate Internet Banking') : $t('Activate Internet Banking')"
              name="enable-internet-banking"
              class="ml-6"
              :readonly="isReadonly"
            />
          </b-col>
        </b-row>
      </b-form>
      <FullScreenSpinner :show="showSpinner" />
    </validation-observer>
    <div class="mt-2">
      <Button
        v-if="getUserPermission('UPDATE_SECURITY_CONFIG')"
        :label="$t('Update')"
        :loading="isLoading"
        :disabled="isDisabled"
        size="lg"
        @click="handleSubmit"
      />
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { mapActions } from 'vuex'
import Button from '../../../../components/button/Button.vue'
import { eChannelsPermission } from '@/helpers/permissions'
import SwitchButton from '../../../../components/switch/Switch.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    ValidationObserver,
    SwitchButton,
    Button,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],

  data() {
    return {
      isLoading: false,
      isDisabled: false,
      enableDisableIBFormData: {
        isActive: false,
      },
      actionType: '',
    }
  },
  mounted() {
    this.fetchEnableDisableInternetBanking()
  },
  methods: {
    ...mapActions({
      getFraudChecks: 'eChannels/getFraudChecksList',
      updateFruadChecks: 'eChannels/updateFraudCheckAction',
    }),
    async fetchEnableDisableInternetBanking() {
      try {
        this.showSpinner = true
        const response = await this.getFraudChecks({
          permission: eChannelsPermission.VIEW_SECURITY_CONFIG,
        })
        const { status, data } = response
        if (status === 200) {
          this.enableDisableIBFormData = {
            isActive: data.isActive,
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async enableDisableTransferAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          isActive: this.enableDisableIBFormData.isActive,
        }
        const response = await this.updateFruadChecks({
          formData, permission: eChannelsPermission.ENABLE_DISABLE_MOBILE_AND_INTERNETBANKING_TRANSFERS,
        })
        const { status } = await response
        if (status === 200) {
          this.hideModal('modal-lg')
          const requestText = this.$t('Your request to')
          const successText = this.$t('was successful')
          this.alertSuccess({ text: `${requestText} ${this.actionType} ${successText}` })
        }
      } catch (error) {
        this.hideModal('modal-lg')
        error.response.data.errors.forEach(responseError => {
          const requestText = this.$t('Your request to')
          const reasonText = this.$t('failed. Reason')
          this.alertError({ text: `${requestText} ${this.actionType} ${reasonText}: ${responseError.errorMessage}` })
        })
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async handleSubmit() {
      if (this.enableDisableIBFormData.isActive) {
        this.actionType = this.$t('Activate Internet Banking')
      } else if (!this.enableDisableIBFormData.isActive) {
        this.actionType = this.$t('Deactivate Internet Banking')
      } else {
        this.actionType = this.$t('Update Internet Banking')
      }
      this.$refs.enableDisableRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          this.confirm(this.enableDisableTransferAction, { text: `${areYouSure} ${this.actionType}?` })
        }
      })
    },
  },
}
</script>
